// Delivery date + gift message cart fields - see snippets/kc-cart-extras.liquid.
// Listeners are delegated on document because the theme morphs/replaces the
// cart drawer markup on every cart change.
(function () {
  if (window.kcCartExtrasReady) return;
  window.kcCartExtrasReady = true;

  var pending = Promise.resolve();
  function save(attrs) {
    pending = pending.then(function () {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    });
    return pending;
  }

  // The server pre-selects the saved date, or the earliest one if none/expired.
  // Store whatever is shown so the order always carries a date.
  var lastSynced = null;
  function syncDefault() {
    var select = document.querySelector('kc-cart-extras [data-kc-date]');
    if (!select || !select.value || select.value === lastSynced) return;
    lastSynced = select.value;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if ((cart.attributes || {})['Delivery date'] !== select.value) save({ 'Delivery date': select.value });
      })
      .catch(function () {});
  }

  function updateCount(gift) {
    var count = gift.closest('kc-cart-extras') && gift.closest('kc-cart-extras').querySelector('[data-kc-count]');
    if (count) count.textContent = gift.value.length + ' / 250';
  }

  var giftTimer;
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-kc-date]')) {
      lastSynced = t.value;
      save({ 'Delivery date': t.value });
    } else if (t.matches && t.matches('[data-kc-gift]')) {
      clearTimeout(giftTimer);
      save({ 'Gift message': t.value.trim() });
    }
  });
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!(t.matches && t.matches('[data-kc-gift]'))) return;
    updateCount(t);
    clearTimeout(giftTimer);
    giftTimer = setTimeout(function () { save({ 'Gift message': t.value.trim() }); }, 400);
  });

  // Make sure the last edit is saved before leaving for checkout.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#checkout');
    if (!btn || btn.dataset.kcFlushed) return;
    e.preventDefault();
    var gift = document.querySelector('kc-cart-extras [data-kc-gift]');
    var select = document.querySelector('kc-cart-extras [data-kc-date]');
    var attrs = {};
    if (gift) attrs['Gift message'] = gift.value.trim();
    if (select && select.value) attrs['Delivery date'] = select.value;
    save(attrs).then(function () {
      btn.dataset.kcFlushed = '1';
      btn.click();
    });
  }, true);

  // Runs whenever a <kc-cart-extras> is (re)inserted.
  class KcCartExtras extends HTMLElement {
    connectedCallback() {
      var gift = this.querySelector('[data-kc-gift]');
      if (gift) updateCount(gift);
      syncDefault();
    }
  }
  if (!customElements.get('kc-cart-extras')) customElements.define('kc-cart-extras', KcCartExtras);
  // Morphs that keep the element but swap its options don't reconnect it.
  document.addEventListener('cart:update', function () { setTimeout(syncDefault, 300); });
})();
